import { render, staticRenderFns } from "./BBoxPanel.vue?vue&type=template&id=2f832b82&"
import script from "./BBoxPanel.vue?vue&type=script&lang=js&"
export * from "./BBoxPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports